<template>

    <div class="data jf">
        <div class="leftRow xy-center" @click="qualificationleft()">
            <i class="el-icon-arrow-left font-size18 font-weight c-2F3134" ref="leftRow"></i>
        </div>
        <div class="chapterInfoBox">
            <div class="slider jf" ref="qualification">
                <div class="chapterInfo xy-center" v-for="(child,i) in list" :key="i" @click="sliding">
                    <div class="name ">{{child.ModuleName}} </div>
                    <div class="topicNum">
                        <div>章节数：{{child.chapterCount}}</div>
                        <div class="topicTotal">题量：{{child.subjectCount}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="rightRow  xy-center" @click="qualificationRight()">
            <i class="el-icon-arrow-right font-size18 font-weight " ref="rightRow" ></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        },
        totalList: {
            type: Array,
            default: () => []
        },
        id: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            righTimer: "",
            leftTimer: ""
        }
    },
    created() {
        this.totalList.forEach(v => {
            v.totalLenghth = v.Modules.length - 3
            v.moveDistance = 0
            v.sped = 0
        });
    },
    mounted() {
        if (this.list.length <= 3) {
            this.$refs.leftRow.style.color = "#CBCED1"
            this.$refs.rightRow.style.color = "#CBCED1"
        }
    },
    methods: {
        sliding(val) {
            if (!this.$store.state.groupInfo.IsIPAuthorize && !this.$store.getters.isLogin) {
                this.$emit("toLogin")
                return;
            }
            this.$router.push({ path: "/question/public", query: { queryId: this.id, from: "home" } })
        },
        qualificationleft() {
            this.totalList.forEach(v => {
                if (v.CategoryID === this.id) {
                    if (!v.sped) {
                        return
                    }
                    if (v.sped === 1) {
                        this.$refs.leftRow.style.color = "#CBCED1"
                        this.$refs.rightRow.style.color = "#56585B"
                    }
                    v.sped--
                    v.moveDistance -= 1.14584
                    this.$nextTick(() => {
                        this.$refs.qualification.style.transform = `translateX(${-v.moveDistance}rem)`
                        this.$refs.qualification.style.transitionDuration = "0.5s"
                    })
                }
            });
        },
        qualificationRight() {
            this.totalList.forEach(v => {
                if (v.CategoryID === this.id) {
                    if (v.sped === v.totalLenghth || v.totalLenghth < 0) {
                        return
                    }
                    this.$refs.leftRow.style.color = "#56585B"
                    if (v.sped === v.totalLenghth - 1) {
                        this.$refs.rightRow.style.color = "#CBCED1"
                    }
                    v.sped++
                    v.moveDistance += 1.14584
                    this.$nextTick(() => {
                        this.$refs.qualification.style.transform = `translateX(-${1.14584 * v.sped}rem)`
                        this.$refs.qualification.style.transitionDuration = "0.5s"
                    })
                }
            });
        }
    }
}

</script>

<style lang="less" scoped>
    .chapterInfoBox {
        width: 640px;
        height: 132px;
        display: flex;
        align-items: center;
        overflow: hidden;

        .chapterInfo {
            width: 200px;
            height: 80px;
            background: #F8FAFF;
            border-radius: 12px;
            flex-shrink: 0;
            margin-right: 20px;

            .name {
                width: 40px;
                display: flex;
                flex-wrap: wrap;
                font-size: 16px;
            }

            .topicNum {
                margin-left: 20px;
                font-size: 14px;
                color: #2F3134;

                .topicTotal {
                    margin-top: 5px;
                }
            }
        }
    }

    .leftRow {
        width: 36px;
        height: 48px;
        background: #F3F5F9;
        border-radius: 3px;
        margin: 0 20px;
    }

    .leftRowActive{
      background-color: pink;
    }

    .rightRow {
        width: 36px;
        height: 48px;
        background: #F3F5F9;
        border-radius: 3px;
        margin: 0 20px;
    }

</style>
